import { Component, OnInit } from '@angular/core';
import { MasterFormComponent } from '../../form/master-form/master-form.component';

@Component({
  selector: 'app-master-blog',
  templateUrl: './master-blog.component.html',
})
export class MasterBlogComponent extends MasterFormComponent {

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/blog/master-blog/master-blog.component.ts